import { Box, Alert, Spacer, GameButton } from "@fedsim/components"
import { STORE_VERSION } from "@fedsim/constants"

import { useMigration } from "pages/migrations/hooks" // todo
import { useGame } from 'hooks/useGame';

export const StoreVersion = () => {
  const { model: game } = useGame()
  const { onRunMigrations } = useMigration()

  if (STORE_VERSION === game?.storeVersion) return null

  return (
    <Box onClick={onRunMigrations}>
      <Alert severity="error"
        action={
          <GameButton color="error" variant="contained" size="small">
            Update
          </GameButton>
        }>
        We think your save game data is out date:
        Click here to update.
        ({STORE_VERSION} vs {game?.storeVersion})
      </Alert>
      <Spacer />
    </Box>
  )
}

export default StoreVersion
